import React, { useState } from "react";
import { BsArrowRight } from "react-icons/bs";
import Slider9 from "../images/studiopic.jpg";
import MeditationTwo from "../images/meditationpic.jpg";
import Prag5 from "../images/corporatepicture.jpg";
import Medi5 from "../images/MediFive.JPG";
import Anth from "../images/antastha.jpg";
import Reiki5 from "../images/reiki.jpg";
import Nidra from "../images/nidrapic.jpg";
import GalleryModal from "../components/galleryModal";

function Gallery() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState({ header: "", paragraph: "" });

  const openModal = (header, paragraph) => {
    setModalData({ header, paragraph });
    setIsModalOpen(true);
  };

  const galleryItems = [
    {
      id: 1,
      image: Slider9,
      title: "Yoga by Jasmin Studio",
      subtitle: "45 Dalkeith Dr Brantford",
      modalContent: {
        header: "What to Expect in My Yoga Classes",
        paragraph: `Yoga doesn’t have to feel intimidating. I hold space for small, heart-centered classes  no more than 6 to 9 students where each person is seen, supported, and gently guided. You’ll receive personal attention, hands-on adjustments if welcome, and the chance to truly slow down and reconnect.

My classes weave together traditional Hatha, breathwork, meditation, and often Yoga Nidra. We move with awareness, pause with purpose, and open to the stillness within. It’s not about doing more — it’s about remembering who you are beneath the noise.

We close each class with rest, reflection, and a warm cup of tea  a quiet moment to integrate, ground, and just be.

If this is something your heart needs and you’re unable to pay at this time, come anyway. Receive the practice, and when you’re able, offer that kindness forward to someone else. That’s yoga too.

Come as you are. This space is for you.`
      }
    },
    {
      id: 2,
      image: MeditationTwo,
      title: "Meditation",
      subtitle: "Discover inner peace through stillness",
      modalContent: {
        header: "Discover Inner Peace through Meditation",
        paragraph: `In our fast-paced world, taking the time to sit quietly and turn inward is a profound gift we can offer ourselves. My meditation classes, available both privately and in groups, are designed to help you cultivate inner awareness and develop the ability to simply be with yourself. Through guided sessions, you'll learn to quiet the mind, connect with your breath, and explore the stillness within. This practice not only brings a deep sense of peace but also nurtures self-compassion, clarity, and a greater connection to your true essence.

Whether you're new to meditation or seeking to deepen your practice, these sessions offer a sanctuary for your mind and spirit. Join me in this journey of self-discovery and embrace the transformative power of sitting with your inner light.`
      }
    },
    {
      id: 3,
      image: Medi5,
      title: "Pranayama",
      subtitle: "Harness the power of breath",
      modalContent: {
        header: "Why Learn Pranayama?",
        paragraph: `We can go several days without food and water, but we can't go for more than a few minutes without our breath. Your breath is the conduit of the life force known as prana. By harnessing the breath and becoming aware of prana, it opens the doors to a new awareness. For me, the awareness of the breath and prana is the key to all things—perception, awareness, unlocking closed doors, and bringing about a new view. Learning simple pranayama techniques, which can be mastered by people of all ages, can significantly improve our physical and mental well-being.`
      }
    },
    {
      id: 4,
      image: Anth,
      title: "Antastha Yoga Workshops",
      subtitle: "Inner exploration through blindfolded practice",
      modalContent: {
        header: "What is Antastha Yoga?",
        paragraph: `Antastha Yoga, developed by Sanjeev Bhanot of Yogalife International, is a unique and profound practice that emphasizes inward focus and deep self-awareness. The term "Antastha" means "from the inside" in Sanskrit, reflecting the practice's core philosophy of inner exploration and self-discovery.

As the first certified Antastha Yoga teacher in Canada, I have had the privilege of studying directly under Sanjeev Bhanot. This method integrates traditional Hatha yoga postures with elements of yoga Nidra and Pranayama, guiding practitioners into a state of heightened inner awareness.

Antastha Yoga is practiced with a blindfold, which minimizes external distractions and enhances proprioception.`
      }
    },
    {
      id: 5,
      image: Reiki5,
      title: "Reiki Healing",
      subtitle: "Universal life energy therapy",
      modalContent: {
        header: "Reiki with Jasmin",
        paragraph: `My Reiki sessions offer a deeply relaxing and healing experience, designed to balance your energy and promote overall well-being. Each session begins with breathwork, a mini meditation, and soothing sound healing to help you settle into a calm and receptive state. From there, I guide you into a tranquil Reiki session, allowing the energy to flow freely and restore balance to your mind, body, and spirit. The entire session lasts one hour, providing ample time for you to unwind and reconnect with yourself.

What is Reiki?
Reiki is a gentle, non-invasive healing practice that originated in Japan. The word "Reiki" comes from the Japanese words "Rei," meaning universal, and "Ki," meaning life energy. Reiki works by channeling this universal life energy through the practitioner's hands to the recipient, promoting physical, emotional, and spiritual healing. It is a holistic therapy that treats the whole person—mind, body, and spirit—rather than focusing solely on symptoms.`
      }
    },
    {
      id: 6,
      image: Prag5,
      title: "Corporate Yoga",
      subtitle: "Workplace wellness programs",
      modalContent: {
        header: "Why Antastha Yoga is Ideal for Corporate Yoga Classes",
        paragraph: `Stress Reduction and Mental Clarity:
In a corporate setting, employees often experience high levels of stress and mental fatigue. Antastha Yoga's focus on pratyahara, or sense withdrawal, helps reduce external distractions, quieting the mind and promoting relaxation. This can lead to a significant reduction in stress levels and an increase in mental clarity, helping employees to be more focused and productive.

Improved Focus and Concentration:
By practicing yoga with a blindfold, employees can enhance their ability to concentrate on their inner experiences.

Enhanced Creativity and Problem-Solving:
The introspective nature of Antastha Yoga encourages deeper self-awareness and mindfulness. This can foster creativity and innovative thinking, allowing employees to approach problems from new perspectives and come up with creative solutions.`
      }
    },


   {
  id: 7,
  image: Nidra,
  title: "Yoga Nidra",
  subtitle: "Workplace wellness programs",
  modalContent: {
    header: "What is Yoga Nidra?",
    paragraph: `Yoga Nidra, often referred to as yogic sleep, is a powerful meditation practice that guides you into a state of deep relaxation and conscious awareness. This state, known as theta, is where profound healing and transformation occur. In theta, the mind is highly receptive, making it an ideal place to plant seeds of intention and manifestation. Yoga Nidra also lowers the bridge between the conscious and unconscious mind, facilitating deep psychological and emotional healing.`
  }
}

  ];

  return (
    <div className="w-full min-h-screen px-4 md:px-9 py-8">
      {isModalOpen && (
        <GalleryModal
          isOpen={isModalOpen}
          header={modalData?.header}
          paragraph={modalData?.paragraph}
          onClose={() => setIsModalOpen(false)}
        />
      )}
      
      {/* Header */}
      <div className="flex items-center justify-between w-full mb-16">
        <div className="flex relative">
        
          <h1 className="text-[#d1a7a5] font-[800] text-[32px] md:text-[90px] md:pl-20 pl-16">
            Gallery
          </h1>
        </div>
        <button className="btn-hover-gallery hidden md:flex items-center gap-2 border border-[#000] py-2 px-8 text-[11px] font-[550] hover:bg-[#d1a7a5] hover:text-white transition-all duration-300">
          VIEW ALL
        
        </button>
      </div>

      {/* Gallery Grid */}
      <div className="max-w-7xl mx-auto">
        {/* Hero Section - Yoga Studio */}
        <div className="mb-20">
          <div className="relative group cursor-pointer" onClick={() => openModal(galleryItems[0].modalContent.header, galleryItems[0].modalContent.paragraph)}>
            <div className="relative overflow-hidden rounded-lg shadow-lg">
              <img
                src={galleryItems[0].image}
                alt={galleryItems[0].title}
                className="w-full h-[400px] md:h-[500px] object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black bg-opacity-30 group-hover:bg-opacity-20 transition-all duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                <h2 className="text-3xl md:text-5xl font-bold mb-2">{galleryItems[0].title}</h2>
                <p className="text-lg md:text-xl opacity-90">{galleryItems[0].subtitle}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Main Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {galleryItems.slice(1, 4).map((item) => (
            <div
              key={item.id}
              className="group cursor-pointer"
              onClick={() => openModal(item.modalContent.header, item.modalContent.paragraph)}
            >
              <div className="relative overflow-hidden rounded-lg shadow-lg mb-4">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-[280px] object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute  bg-black bg-opacity-20 group-hover:bg-opacity-10 transition-all duration-300"></div>
              </div>
              <div className="px-2">
                <h3 className="text-xl md:text-2xl font-semibold text-[#6d806b] mb-2 group-hover:text-[#d1a7a5] transition-colors duration-300">
                  {item.title}
                </h3>
                <p className="text-[#848484] text-sm md:text-base">{item.subtitle}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Section - Reiki & Corporate */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {galleryItems.slice(4, 7).map((item) => (
            <div
              key={item.id}
              className="group cursor-pointer"
              onClick={() => openModal(item.modalContent.header, item.modalContent.paragraph)}
            >
              <div className="relative overflow-hidden rounded-lg shadow-lg mb-4">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-[320px] object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute  bg-black bg-opacity-20 group-hover:bg-opacity-10 transition-all duration-300"></div>
              </div>
              <div className="px-2">
                <h3 className="text-2xl md:text-3xl font-semibold text-[#6d806b] mb-2 group-hover:text-[#d1a7a5] transition-colors duration-300">
                  {item.title}
                </h3>
                <p className="text-[#848484] text-base md:text-lg">{item.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Gallery;